export const blockedMessages = {
  deleted: {
    titleKey: 'blocked.deleted.title',
    bodyKey: 'blocked.deleted.body',
    footerKey: 'blocked.deleted.footer',
  },
  banned: {
    titleKey: 'blocked.banned.title',
    bodyKey: 'blocked.banned.body',
    footerKey: 'blocked.banned.footer',
  },
  uk_restriction: {
    titleKey: 'blocked.uk_restriction.title',
    bodyKey: 'blocked.uk_restriction.body',
    footerKey: 'blocked.uk_restriction.footer',
  },
};
